import styled from "styled-components";

export const PanelWrapper = styled("div")`
  position: fixed;
  width: 380px;
  max-height: 480px;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const PanelHeader = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
`;

export const PanelTitle = styled("h3")`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #2d3436;
`;

export const MarkAllButton = styled("button")`
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  color: #6C5CE7;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: rgba(45, 52, 54, 0.3);
    cursor: default;
    text-decoration: none;
  }
`;

export const PanelBody = styled("div")`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
`;

export const EmptyState = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  gap: 12px;
`;

export const EmptyText = styled("p")`
  margin: 0;
  font-size: 14px;
  color: rgba(45, 52, 54, 0.45);
`;

export const LoadingWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

